var icon = require('vue-svgicon')
icon.register({
  'ks-icon-phone': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M38.89 58.35a70.45 70.45 0 0 0 30.76 30.76l10.26-10.27a4.69 4.69 0 0 1 4.76-1.17 53 53 0 0 0 16.66 2.66A4.67 4.67 0 0 1 106 85v16.33a4.67 4.67 0 0 1-4.67 4.67A79.33 79.33 0 0 1 22 26.67 4.67 4.67 0 0 1 26.67 22H43a4.67 4.67 0 0 1 4.67 4.67 53 53 0 0 0 2.66 16.66 4.69 4.69 0 0 1-1.17 4.76z"/>'
  }
})
